import { put, takeLatest } from "@redux-saga/core/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import useLoading from "../../../common/customHook/useLoading";
import { handleNotificationAlertCatch, handleNotificationAlertTrySelect, handleNotificationAlertTryUpdate } from "../../../common/method/handleNotificationAlert";



export const actionTypes = {
    selectPortfolio: "[selectPortfolio] Action",
    selectPortfolioEmpty: "[selectPortfolioEmpty] Action",
    selectPortfolioAsync: "[selectPortfolioAsync] Action",
    selectPortfolioLoading: "[selectPortfolioLoading] Action",
}



const initialState = {
    data: [],
    loading: false,
    total:0
}

export const select_portfolio_reducer = (state = initialState, { type, payload }) => {

    switch (type) {
        case actionTypes.selectPortfolio:
            return {
                ...state,
                data: payload?.data?.results ? payload?.data?.results : [],
                total:payload?.data?.total ? payload?.data?.total : 0,
            }
        case actionTypes.selectPortfolioEmpty:
            return {
                ...state,
                data: []
            }
        case actionTypes.selectPortfolioLoading:
            return {
                ...state,
                loading: payload,
            }
        default:
            return state;
    }
}




function* handleWorker({ payload }) {

    yield put({ type: actionTypes.selectPortfolioLoading, payload: true })

   



    let config = {
        url: "select_request"
    };

    let data = {
        table: "portfolio",
        method_type: "select_portfolio",
        data: payload?.data ? payload.data : {},
    };

    try {
        let res = yield AxiosCustom(config, data);
        let isOk = handleNotificationAlertTrySelect(res);
        if (!isOk) {
          return;
        }
        yield put({ type: actionTypes.selectPortfolio, payload: res?.data?.response })
    } catch {
        handleNotificationAlertCatch();
    } finally {
        yield put({ type: actionTypes.selectPortfolioLoading, payload: false })

    }
}

export function* selectPortfolio() {
    yield takeLatest(actionTypes.selectPortfolioAsync, handleWorker);
}
